const styles = () => ({
    underReview: {
        textAlign: 'center',
    },
});

export default styles;
